<template>
  <div>
    <!-- select 2 demo -->

    <b-modal
      id="modal-login"
      centered
      ok-only
      hide-footer="true"
      title="Terms & Conditions"
    >
      <b-form>
        <b-form-group label="Term" invalid-feedback="Term is required.">
          <b-form-input
            id="name-input"
            ref="name"
            placeholder="Enter term here."
            required
            @focusout="CheckName()"
            v-model="myObj.term"
          />
        </b-form-group>
        <b-form-group
          v-if="adding"
          label="Language"
          invalid-feedback="language is required."
          ref="lang"
        >
          <v-select
            ref="lang"
            placeholder="Select language."
            v-model="myObj.language"
            :options="langOptions"
            :reduce="(opt) => opt.value"
            label="text"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :clearable="false"
          />
        </b-form-group>
      </b-form>
      <br />
      <div style="">
        <b-button
          class="float-right ml-5"
          variant="primary"
          @click="AddFlavour()"
        >
          <b-spinner
            v-if="request"
            variant="light"
            type="grow"
            small
            label="Spinning"
          ></b-spinner>
          <span v-if="!request" class="text-nowrap">Save</span>
        </b-button>
      </div>
    </b-modal>

    <b-card no-body class="mb-0">
      <div class="m-2">
        <b-row>
          <!-- <b-col class="mt-2" md="2" sm="8">
            <b-button @click="OpenAddModal(0)" variant="primary">
              <feather-icon icon="PlusIcon" class="mr-50" />
              <span class="text-nowrap">Add Term</span>
            </b-button>
          </b-col> -->
          <b-col class="mt-2">
            <div class="d-flex align-items-center justify-content-start">
              <b-button
                @click="FilterLang('english')"
                variant="warning"
                class="mr-1"
              >
                <span class="text-nowrap">English</span>
              </b-button>
              <b-button
                @click="FilterLang('arabic')"
                variant="success"
                class="mr-1"
              >
                <span class="text-nowrap">Arabic</span>
              </b-button>
              <b-button
                @click="FilterLang('french')"
                variant="info"
                class="mr-1"
              >
                <span class="text-nowrap">French</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="m-1">
        <VueTrix ref="name" v-model="myObj.term" placeholder="Enter content" />
        <div style="margin: 10px 0px;">
          <b-button
            class="float-right ml-5"
            variant="primary"
            :disabled="request"
            @click="AddFlavour()"
          >
            <b-spinner
              v-if="request"
              variant="light"
              type="grow"
              small
              label="Spinning"
            ></b-spinner>
            <span v-if="!request" class="text-nowrap">Save</span>
          </b-button>
        </div>
      </div>

      <!-- <div>
        <b-table :items="items" :fields="fields" striped>
          <template #cell(#)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(icon)="data">
            <b-img
              :src="data.value"
              style="width: 100px; height: 100px; object-fit: cover"
              rounded
              alt="Rounded image"
            />
          </template>

          <template #cell(actions)="data">
            <template>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-icon"
                v-b-tooltip.hover.v-primary
                v-b-tooltip.placement.left
                title="Edit"
                @click="OpenAddModal(data.item.id)"
              >
                <feather-icon size="16" icon="EditIcon" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-danger"
                class="ml-1 btn-icon"
                v-b-tooltip.hover.v-danger
                v-b-tooltip.placement.right
                title="Delete"
                size="16"
                @click="DeleteFlavour(data.item)"
              >
                <feather-icon size="16" icon="XIcon" />
              </b-button>
            </template>
          </template>
        </b-table> 
      </div>
      -->
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BMediaAside,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BSpinner,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
//import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from "@core/utils/filter";
//import useAllOrdersList from './useAllOrdersList'
//import orderStoreModule from '../allordersStoreModule'
import flatPickr from "vue-flatpickr-component";
import { BFormSelect } from "bootstrap-vue";
//import Multiselect from "vue-multiselect";
import VueGallery from "vue-gallery";
import Ripple from "vue-ripple-directive";
import VueTrix from "vue-trix";

export default {
  components: {
    //Multiselect,
    VueTrix,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BMediaAside,
    BSpinner,
    BImg,
    BMedia,
    BFormGroup,
    //BAvatar,
    BLink,
    //BBadge,
    //BDropdown,
    //BDropdownItem,
    BPagination,
    vSelect,
    BFormCheckbox,
    //flatPickr,
    //'gallery': VueGallery
  },
  props: {
    /* modalFilter: {
    type: [String, null],
    default: null,
    },
    modalFilterOptions: {
    type: Array,
    required: true,
    }*/
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  created() {
    this.LoadData("english");
  },
  data() {
    return {
      token:
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJPc2FtYSIsImVtYWlsIjoib3NhbWF1c21hbjU1NUBnbWFpbC5jb20iLCJqdGkiOiJjMzI0MGI0ZS1mM2NlLTQxZGUtYmRmNS1iYTE1YTFjMjkyZDIiLCJleHAiOjE2NzA1NjU2MjQsImlzcyI6ImFwcGlja3NvbHV0aW9ucy5pby5jb20iLCJhdWQiOiJhcHBpY2tzb2x1dGlvbnMuaW8uY29tIn0.0_pK3DJcXTTEAk-fFziiMOkgGUC7nUYXppJ9C7dOIic",
      plus: "",
      fileProfile: "",
      logoloading: false,
      errors: {
        status: false,
      },
      langOptions: [
        { text: "English", value: "english" },
        { text: "Arabic", value: "arabic" },
        { text: "French", value: "french" },
      ],
      filterLang: [],
      index: null,
      fields: ["#", { label: "term", key: "term" }, "actions"],
      items: [],
      request: false,
      categoryOptions: [],
      myObj: {
        id: 0,
        term: "",
        language: "",
      },
      searchQuery: "",
      adding: false,
    };
  },
  methods: {
    SearchData() {
      if (this.searchQuery.length > 0) {
        var data = this.items.filter(
          (data) =>
            JSON.stringify(data)
              .toLowerCase()
              .indexOf(this.searchQuery.toLowerCase()) !== -1
        );
        this.items = data;
      } else {
        this.LoadData();
      }
    },
    CheckName() {
      var elem = this.$refs["name"];
      if (this.myObj.term == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckImage() {
      console.log(this.myObj.icon);
      var elem = this.$refs["image"];
      if (this.myObj.icon == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckLang() {
      if (this.adding) {
        var elem = this.$refs["lang"];
        if (this.myObj.language == "") {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    OpenAddModal(id) {
      if (id != 0) {
        var axios = require("axios");
        var config = {
          method: "get",
          url:
            "https://geotalent-backend-production.up.railway.app/api/Terms/" +
            id,
          headers: {
            Authorization: "bearer " + this.$store.state.userData.token,
          },
        };

        axios(config)
          .then((response) => {
            console.log(response);
            this.myObj = response.data.data;
            this.adding = false;
            this.$bvModal.show("modal-login");
          })
          .catch(function(error) {
            console.log(error);
          });
      } else {
        this.myObj = {
          id: 0,
          term: "",
          language: "",
        };
        this.adding = true;
        this.$bvModal.show("modal-login");
      }
    },
    DeleteFlavour(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          var axios = require("axios");
          var config = {
            method: "delete",
            url:
              "https://geotalent-backend-production.up.railway.app/api/Terms/" +
              item.id,
            headers: {
              Authorization: "bearer " + this.$store.state.userData.token,
            },
          };
          console.log(config.url);
          axios(config)
            .then((response) => {
              console.log(response.data);
              if (response.data.status === "success") {
                Swal.fire("Success!", "Term has been deleted.", "success").then(
                  (res) => {
                    this.LoadData(item.language);
                  }
                );
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      });
    },
    selectlogo() {
      this.fileProfile = this.$refs.fileProfile.files[0];
      console.log(this.fileProfile);
      var axios = require("axios");
      if (this.fileProfile !== "") {
        this.logoloading = true;
        let formData = new FormData();
        formData.append("file", this.fileProfile);
        formData.append("upload_preset","geotalent")
        axios
          .post("https://api.cloudinary.com/v1_1/dr9m7dwjw/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })

          .then((e) => {
            console.log(e.data);
            var fn1 = e.data.url;
            console.log(fn1);
            this.plus = fn1;
            this.myObj.icon = this.plus;
            // console.log(this.plus);
            this.logoloading = "loaded";
            this.CheckImage();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    deleteLogo() {
      //console.log(0);
      this.myObj.icon = "";
      this.logoloading = false;
      this.$refs.fileProfile.value = null;
    },
    AddFlavour() {
      this.CheckName();
      if (this.CheckName() == false) {
        return this.$bvToast.toast("Please enter the term", {
          title: "Error!",
          variant: "danger",
          toaster: "b-toaster-bottom-center",
        });
      } else {
        console.log("Obj", this.myObj);
        this.request = true;
        if (this.myObj.id == 0) {
          var axios = require("axios");
          var config = {
            method: "post",
            url:
              "https://geotalent-backend-production.up.railway.app/api/Terms",
            headers: {
              Authorization: "bearer " + this.$store.state.userData.token,
            },
            data: this.myObj,
          };

          axios(config)
            .then((response) => {
              if (response.data.status === "success") {
                console.log(response.data);
                Swal.fire("Success!", "Term added.", "success").then((res) => {
                  // this.$bvModal.hide("modal-login");
                  this.LoadData(this.myObj.language);
                  this.request = false;
                });
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
          //Edit
          console.log("edit_Obj", this.myObj);
          this.request = true;
          var axios = require("axios");
          // this.$store.state.userData.userID
          var config = {
            method: "put",
            url:
              "https://geotalent-backend-production.up.railway.app/api/Terms/" +
              this.myObj.id,
            headers: {
              Authorization: "bearer " + this.$store.state.userData.token,
            },
            data: this.myObj,
          };
          axios(config)
            .then((response) => {
              console.log(response.data);
              if (response.data.status === "success") {
                // this.$bvModal.hide("modal-login");
                this.LoadData(this.myObj.language);
                this.request = false;
                this.$bvToast.toast("Term updated.", {
                  title: "Success!",
                  variant: "success",
                  toaster: "b-toaster-top-center",
                });
              } else {
                this.$bvToast.toast("Something went wrong.", {
                  title: "Error!",
                  variant: "danger",
                  toaster: "b-toaster-bottom-center",
                });
                this.request = false;
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      }
    },
    LoadData(text) {
      console.log(text);
      var axios = require("axios");
      var config = {
        method: "get",
        url: "https://geotalent-backend-production.up.railway.app/api/Terms",
        headers: {
          Authorization: "bearer " + this.$store.state.userData.token,
        },
      };

      axios(config)
        .then((response) => {
          console.log(response);
          this.allItems = response.data.data;
          // this.items = response.data.data;
          this.FilterLang(text);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    FilterLang(text) {
      // this.items = this.allItems.filter((el) => el.language == text);
      // console.log(this.items);
      this.filterLang = this.allItems.filter((el) => el.language == text);
      console.log(this.filterLang);
      if (this.filterLang.length != 0) {
        this.myObj = this.filterLang[0];
      } else {
        this.myObj = {
          id: 0,
          term: "",
          language: text,
        };
        console.log(this.myObj);
      }
      // var axios = require("axios");
      // var config = {
      //   method: "get",
      //   url: "https://geotalent-backend-production.up.railway.app/api/Terms",
      //   headers: {
      //     Authorization: "bearer " + this.$store.state.userData.token,
      //   },
      // };

      // axios(config)
      //   .then((response) => {
      //     console.log(response);
      //     this.items = response.data.data;
      //   })
      //   .catch(function(error) {
      //     console.log(error);
      //   });
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
</style>
